(function () {
  const bodyOpenClass = 'krasis-pdp-lightbox-is-open';

  document.querySelectorAll('[data-krasis-pdp]').forEach((section) => {
    const dialog = section.querySelector('[data-krasis-pdp-lightbox]');
    const image = section.querySelector('[data-krasis-lightbox-image]');
    const triggers = Array.from(section.querySelectorAll('[data-krasis-lightbox-trigger]'));
    const thumbs = Array.from(section.querySelectorAll('[data-krasis-lightbox-thumb]'));
    const closeButton = section.querySelector('[data-krasis-lightbox-close]');

    if (!dialog || !image || triggers.length === 0 || thumbs.length === 0) return;

    let activeIndex = 0;

    const setActiveImage = (index) => {
      const nextIndex = Number(index);
      const activeThumb = thumbs.find((thumb) => Number(thumb.dataset.index) === nextIndex) || thumbs[0];

      if (!activeThumb) return;

      activeIndex = Number(activeThumb.dataset.index) || 0;
      image.src = activeThumb.dataset.full;
      image.alt = activeThumb.dataset.alt || '';

      thumbs.forEach((thumb) => {
        const isActive = Number(thumb.dataset.index) === activeIndex;
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    };

    const openLightbox = (index) => {
      setActiveImage(index);
      document.body.classList.add(bodyOpenClass);

      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
    };

    const closeLightbox = () => {
      if (dialog.open && typeof dialog.close === 'function') {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }

      document.body.classList.remove(bodyOpenClass);
    };

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => openLightbox(trigger.dataset.index));
    });

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => setActiveImage(thumb.dataset.index));
    });

    closeButton?.addEventListener('click', closeLightbox);

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closeLightbox();
    });

    dialog.addEventListener('close', () => {
      document.body.classList.remove(bodyOpenClass);
    });

    dialog.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeLightbox();
        return;
      }

      if (event.key === 'ArrowRight') {
        event.preventDefault();
        setActiveImage((activeIndex + 1) % thumbs.length);
      }

      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        setActiveImage((activeIndex - 1 + thumbs.length) % thumbs.length);
      }
    });
  });
})();
